import { Result, Icon, WhiteSpace, Button } from "antd-mobile-v2";
import React, { Component } from "react";
import { createForm } from "rc-form";
import "./index.less";
import tool from "../../api/tool";
import sectionData from "../../api/service/secsstion";
class SucessController extends Component {
  constructor(props) {
    super(props);
     this.state={
      orgName:""
     }
  }
  componentDidMount() {
    let ceptName = sectionData.get("qiYName");
    this.setState({ orgName: ceptName ? ceptName : "中国石化" });
  }
  render() {
    return (
      <div className="sucess-cont">
        <div>
          <Result
            img={
              <Icon
                type="check-circle"
                className="spe"
                style={{ fill: "#1F90E6" }}
              />
            }
            title="提交成功"
            message={`您的${
              this.props.location &&
              this.props.location.state &&
              this.props.location.state.subMiTitle
                ? this.props.location.state.subMiTitle
                : "事项"
            }已提交，${this.state.orgName}信访部门将按照《信访工作条例》有关规定办理，请耐心等待，不要就同一事项重复提交。`}
          />
        </div>
        <div className="btn-cont">
          <Button
            type="primary"
            style={{ marginTop: "0.5rem" }}
            onClick={() => {
              tool.remove("asscateData");
              tool.remove("submitData");
              tool.remove("formData");
              this.props.history.push("/home");
            }}
          >
            返回首页
          </Button>
        </div>
      </div>
    );
  }
}
export default SucessController;
